import { Box, Button, Typography } from '@mui/material';
import React, { ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

// Without this, an exception while rendering any page unmounts the whole app and
// leaves a white screen. Keyed by the route in AppLayout, so navigating resets it.
export default class PageErrorBoundary extends React.Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error('Page crashed', error, info.componentStack);
    }

    render(): ReactNode {
        if (!this.state.hasError) {
            return this.props.children;
        }
        return (
            <Box sx={{ p: 4 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>Something went wrong while loading this page.</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Please reload the page. If it keeps happening, contact Schedula support.
                </Typography>
                <Button variant="contained" onClick={() => window.location.reload()}>Reload</Button>
            </Box>
        );
    }
}
